<app-block-wrapper [_editable]="_editable" [style]="style">
  <a
    appButton
    [name]="analyticsName || 'custom-button'"
    location="storyblok-button"
    [attr.target]="link.target"
    [color]="buttonStyle"
    [spacing]="buttonSpacing"
    [height]="buttonSize"
    [center]="alignment === 'center'"
    [desktopAlignment]="desktopAlignment"
    [tabletAlignment]="tabletAlignment"
    [mobileAlignment]="mobileAlignment"
    [weight]="bold ? 'bold' : 'normal'"
    shape="round"
    [size]="textSize"
    [hasIcon]="!!icon && !!label"
    [iconButton]="!!icon && !label"
    [verticalIcon]="iconPosition === 'bottom'"
    [href]="link | storyblokLinkUrl"
    (click)="onClick($event)"
  >
    @if (icon && iconPosition === 'left') {
      <app-svg src="assets/icons/{{ icon }}.svg"></app-svg>
    }
    <span>{{ label }}</span>
    @if (icon && iconPosition === 'right') {
      <app-svg src="assets/icons/{{ icon }}.svg"></app-svg>
    }
    @if (icon && iconPosition === 'bottom') {
      <app-svg src="assets/icons/{{ icon }}.svg" class="bottom-button"></app-svg>
    }
  </a>
</app-block-wrapper>
